// The lazy wrapper of the Markdown renderer (SEP-380). The renderer and its
// parser are about a third of the first download when they load with the
// shell, because the review drawer of the root layout renders Markdown. This
// wrapper loads them when a body first renders. The props type is a type-only
// import, so an import of this wrapper does not put the renderer into the
// chunk of its importer.

import { lazy, Suspense } from 'react';
import type { MarkdownRendererProps } from './markdown-renderer';

const MarkdownRenderer = lazy(() => import('./markdown-renderer'));

export default function Markdown(props: MarkdownRendererProps) {
    return (
        <Suspense fallback={null}>
            <MarkdownRenderer {...props} />
        </Suspense>
    );
}
